<template>
  <div id="app">
    <EventBrowser :selected-event-types="selectedEventTypes" :selected-tags="selectedTags" :domain="domain"/>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import EventBrowser from './components/EventBrowser.vue';

export default defineComponent({
  name: 'App',
  props: {
    domain: {
      type: String,
      default: 'dgm.inventum.de'
    },
    selectedEventTypes: {
      type: Array,
      default: () => []
    },
    selectedTags: {
      type: Array,
      default: () => []
    }
  },
  components: {
    EventBrowser
  }
});
</script>

<style lang="scss">

</style>
